import { useEffect } from "react";
import { motion } from "framer-motion";
import { LOGO_MASK } from "./Primitives";

const EASE = [0.65, 0, 0.35, 1];

export const Intro = ({ onDone }) => {
  useEffect(() => {
    const t = setTimeout(onDone, 2600);
    return () => clearTimeout(t);
  }, [onDone]);

  return (
    <motion.div
      data-testid="intro-screen"
      onClick={onDone}
      initial={{ y: 0 }}
      exit={{ y: "-100%", transition: { duration: 1, ease: EASE } }}
      className="fixed inset-0 z-[90] flex cursor-pointer flex-col items-center justify-center bg-espresso px-6"
    >
      <div className="relative overflow-hidden">
        <motion.img
          src="/img/logo-amadeus-nav.png"
          alt="Café Amadeus"
          initial={{ clipPath: "inset(0 100% 0 0)", filter: "blur(10px)", opacity: 0.3 }}
          animate={{ clipPath: "inset(0 0% 0 0)", filter: "blur(0px)", opacity: 1 }}
          transition={{ duration: 1.6, ease: EASE, delay: 0.2 }}
          className="h-auto w-[260px] sm:w-[340px]"
        />
        <span aria-hidden="true" style={LOGO_MASK} className="pointer-events-none absolute inset-0 overflow-hidden">
          <motion.span
            initial={{ x: "-120%" }}
            animate={{ x: "240%" }}
            transition={{ duration: 1.1, ease: "easeInOut", delay: 1.5 }}
            className="absolute inset-y-0 left-0 w-1/2 skew-x-[-20deg] bg-gradient-to-r from-transparent via-white/80 to-transparent"
          />
        </span>
      </div>
      <motion.span
        initial={{ scaleX: 0 }}
        animate={{ scaleX: 1 }}
        transition={{ duration: 1.4, ease: EASE, delay: 0.5 }}
        className="mt-8 block h-px w-40 origin-left bg-gold/60"
      />
      <motion.p
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 1.2 }}
        className="mt-5 font-sans text-xs uppercase tracking-[0.35em] text-sand"
      >
        Querétaro · Seit 1986
      </motion.p>
    </motion.div>
  );
};
